export default "__VITE_ASSET__5d7e0eb8__"